// 菜单
export default [
  // index
  { path: '/index', title: '首页', icon: 'home' }
]
